const defaultQueryKeys = ['page'];

/**
 * Filter current query string to only contain certain keys that are relevant for GA's virtual page view
 * @param queryString The complete query string of a location
 * @param keys List of allowed query string keys
 */
export const getFilteredQueryStringForVirtualPageView = (
    queryString: string,
    keys: string[] = [],
) => {
    const triggerKeys = [...defaultQueryKeys, ...keys];

    const searchParams = new URLSearchParams(queryString);

    const filteredSearchParams = Array.from(searchParams.entries())
        .filter(([key]) => triggerKeys.includes(key))
        .reduce((acc, [key, value]) => {
            acc.set(key, value.toString());
            return acc;
        }, new URLSearchParams());

    return filteredSearchParams.toString();
};
